// Calendar date (YYYY-MM-DD, UTC) for a Firestore Timestamp, a Date, or an
// ISO string. The backend's case_as_of reads the same UTC date from the
// case document, so a case's fiscal-year table matches on both sides.
export function toIsoDate(value) {
    if (value == null) return undefined;
    let date;
    if (typeof value.toDate === 'function') {
        date = value.toDate();
    } else if (value instanceof Date) {
        date = value;
    } else if (typeof value === 'string') {
        date = new Date(value);
    } else {
        return undefined;
    }
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return undefined;
    return date.toISOString().slice(0, 10);
}
